import { forwardRef } from 'react';
import SVGLogo from 'assets/logo/logo_black.svg';
import { StyledLogo } from './styles';
import { LogoProps } from './types';

export const Logo = forwardRef(({ size = 45 }: LogoProps) => (
  <StyledLogo $size={size}>
    <SVGLogo
      viewBox='0, 0, 171, 160'
      height={size}
      width={size}
      aria-hidden="true"
    />
  </StyledLogo>
));
